import type { ISankeySeriesTheme } from '../../../../series/sankey/interface';

export const sankey: ISankeySeriesTheme = {
  link: {
    style: {
      // lineWidth: 0,
      fillOpacity: 0.15,
      round: true
    }
  }
};
